export enum DetailType {
    CROSS_SELLING = 'cross_selling',
    DESCRIPTION = 'description',
}
